import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './Loading.scss';

const Loading = props => (
  <div
    className={cx('loading', {
      'loading--dark': props.dark,
      'loading--relative': props.relative,
      'loading--absolute': props.absolute,
      'loading--fade': props.fade,
      'loading--xsmall': props.xsmall,
      'loading--small': props.small,
      [props.className]: props.className,
    })}>
    <span className="loading-indicator" />
  </div>
);

export const LoadComponent = props => {
  if (props.isLoading) {
    return <Loading {...props} />;
  }
  return props.children;
};

Loading.propTypes = LoadComponent.propTypes = {
  dark: PropTypes.bool,
  relative: PropTypes.bool,
  absolute: PropTypes.bool,
  xsmall: PropTypes.bool,
  small: PropTypes.bool,
  fade: PropTypes.bool,
  className: PropTypes.string,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Loading/Loading.js